import React, { memo } from 'react';
import { Col, Row } from 'react-bootstrap';
import FilterPanel from '@spark/ui-components/components/FilterPanel';
import { filterConfig } from '../config/filterConfig';

const ProgramacaoFilter = ({ loading = false, onApply, onLimpar }) => (
  <Row>
    <Col md={12}>
      <FilterPanel
        filters={filterConfig}
        onApply={onApply}
        onLimpar={onLimpar}
        title="Filtros de Programação"
        loading={loading}
        defaultCollapsed
      />
    </Col>
  </Row>
);

export default memo(ProgramacaoFilter);
